import api from "./api";

import { BASE_URL_AUTH } from "../constants";

export default class AuthApiCaller {
  static Get(endPoint = "", params = {}, headers = {}) {
    return api
      .get(`${BASE_URL_AUTH}${endPoint}`, { params, headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static PostSignin = async (endPoint = "", body = {}, headers = {}) => {
    const response = await fetch(`${BASE_URL_AUTH}${endPoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        requestedfrom: "web",
      },
      body: JSON.stringify(body),
    });
    const jsonData = await response.json();
    return { status: response.status, ...jsonData };
  };

  static Post(endPoint = "", body = {}, headers = {}) {
    return api
      .post(`${BASE_URL_AUTH}${endPoint}`, body, { headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static Put(endPoint = "", body = {}, headers = {}) {
    return api
      .put(`${BASE_URL_AUTH}${endPoint}`, body, { headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static Delete(endPoint = "", body = {}, headers = {}) {
    return api
      .delete(`${BASE_URL_AUTH}${endPoint}`, { data: body, headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }
}
